/* Empty string means allow all versions */
export const BROWSER_CHROME_ALLOWED_VERSIONS = '';
export const BROWSER_FIREFOX_ALLOWED_VERSIONS = '';
export const BROWSER_SAFARI_ALLOWED_VERSIONS = '>=14.x.x';
export const BROWSER_OPERA_ALLOWED_VERSIONS = '';
export const BROWSER_EDGE_ALLOWED_VERSIONS = '';
// Bans IE versions
export const BROWSER_IE_ALLOWED_VERSIONS = '<=0.0.0';
